import { applyAuth0Theme } from "@/utils/theme/themeEngine";

import MfaSmsEnrollmentForm from "./components/MfaSmsEnrollmentForm";
import { useMfaSmsEnrollmentManager } from "./hooks/useMfaSmsEnrollmentManager";
import { AuthLayout } from "@/components/auth/AuthLayout";

function MfaSmsEnrollmentScreen() {
    // Extracting attributes from hook made out of MfaSmsEnrollment instance of Auth0 React ACUL SDK
    const { mfaSmsEnrollment, texts, locales } = useMfaSmsEnrollmentManager();

    applyAuth0Theme(mfaSmsEnrollment);
    return (
        <AuthLayout title={texts?.pageTitle || locales?.page?.title}>

            <MfaSmsEnrollmentForm />
            </AuthLayout>
    );
}

export default MfaSmsEnrollmentScreen;
